import React from 'react';

//assets
import { EyeOffIcon, EyeOnIcon } from 'assets/icons';

//styles
import { IconWrapper } from './EyeOnOff.styled';
import { useTheme } from 'styled-components';

interface IEyeOnOff {
  onClick: () => void;
  iconName: string;
  inputSuffix: boolean;
  alt?: string;
  position?: string;
}

export const EyeOnOff = ({ iconName, onClick, inputSuffix, position }: IEyeOnOff) => {
  const { colors } = useTheme();

  const icons = {
    EyeOn: <EyeOnIcon width={16} height={16} strokeWidth={1.5} />,
    EyeOff: <EyeOffIcon width={16} height={16} strokeWidth={1.5} />,
  };

  return (
    <IconWrapper
      style={{ display: 'flex', justifyContent: 'flex-end' }}
      inputSuffix={inputSuffix}
      onClick={onClick}
      stroke={colors.black_40}
      position={position}
    >
      {icons[iconName as keyof typeof icons]}
    </IconWrapper>
  );
};
